import { useQuery } from '@tanstack/react-query';
import { importService } from '../api/api';
import { BatchDetailResponse } from '../types';

export const useBatchDetail = ({ page, limit, batchHeaderId }: { page: number, limit: number, batchHeaderId?: string }) => {

    const { data, isLoading, error, isError } = useQuery<BatchDetailResponse>({
        queryKey: ['batchDetail', { page, limit, batchHeaderId }],
        queryFn: () => importService.getBatchDetail({ page, limit, batchHeaderId }),
    });

    return {
        data: data?.rows || [],
        pagination: data?.pagination,
        isLoading,
        error,
        isError
    };

};